<template>
	<div id="search">

		<b-field horizontal>

			<b-input type="text"
					 icon="search"
					 expanded
					 v-model="search.Keywords"
					 placeholder="search by name or model"
					 icon-right="close-circle"
					 icon-right-clickable
					 @icon-right-click="search.Keywords = ''"></b-input>
			<div class="control">
				<b-button class="is-primary" @click="searchAircraft">Search</b-button>
			</div>

			<b-button class="is-default" @click="showAdvanced = !showAdvanced">{{ showAdvanced == true ? "Hide" : "Show" }} advanced search</b-button>
		</b-field>

		<div v-if="showAdvanced == true">
			<h2 class="subtitle">Advanced search</h2>
			<div class="columns">
				<div class="column is-7">
					<b-field label="Aircraft type">
						<b-taginput placeholder="Select a type"
									autocomplete
									open-on-focus
									field="Name"
									:data="types"
									v-model="selectedTypes">
						</b-taginput>
					</b-field>
					<b-field label="Manufacturer">
						<b-taginput placeholder="Select a manufacturer"
									autocomplete
									open-on-focus
									field="Name"
									:data="manufacturers"
									v-model="selectedManufacturers">
						</b-taginput>
					</b-field>
					<b-field label="Aircraft model">
						<b-taginput placeholder="Select a model"
									autocomplete
									open-on-focus
									field="Name"
									:data="models"
									v-model="selectedModels">
						</b-taginput>
					</b-field>
				</div>
				<div class="column is-5">
					<b-field grouped label="Flight hours">
						<b-field>
							<b-radio-button v-model="search.HourOperator"
											native-value="<"
											type="is-light-primary"
											class="search-radio is-primary">
								<span>&lt;</span>
							</b-radio-button>
							<b-radio-button v-model="search.HourOperator"
											native-value="="
											type="is-light-primary"
											class="search-radio">
								<span>=</span>
							</b-radio-button>
							<b-radio-button v-model="search.HourOperator"
											native-value=">"
											type="is-light-primary"
											class="search-radio">
								<span>{{ ">" }}</span>
							</b-radio-button>
						</b-field>
						<b-field expanded><b-input type="number" v-model="search.FlightHours" :step="0.01"></b-input></b-field>
					</b-field>
					<b-field grouped label="Cycles">
						<b-field>
							<b-radio-button v-model="search.CycleOperator"
											native-value="<"
											type="is-light-primary"
											class="search-radio">
								<span>&lt;</span>
							</b-radio-button>
							<b-radio-button v-model="search.CycleOperator"
											native-value="="
											type="is-light-primary"
											class="search-radio">
								<span>=</span>
							</b-radio-button>
							<b-radio-button v-model="search.CycleOperator"
											native-value=">"
											type="is-light-primary"
											class="search-radio">
								<span>{{ ">" }}</span>
							</b-radio-button>
						</b-field>
						<b-field expanded><b-input expanded type="number" v-model="search.Cycles"></b-input></b-field>
					</b-field>
					<b-field grouped label="Annual CO2 emissions (tonnes)">
						<b-field>
							<b-radio-button v-model="search.EmissionOperator"
											native-value="<"
											type="is-light-primary"
											class="search-radio">
								<span>&lt;</span>
							</b-radio-button>
							<b-radio-button v-model="search.EmissionOperator"
											native-value="="
											type="is-light-primary"
											class="search-radio">
								<span>=</span>
							</b-radio-button>
							<b-radio-button v-model="search.EmissionOperator"
											native-value=">"
											type="is-light-primary"
											class="search-radio">
								<span>{{ ">" }}</span>
							</b-radio-button>
						</b-field>
						<b-field expanded>
							<b-input type="number" v-model="search.Emissions"></b-input>
						</b-field>
					</b-field>
				</div>
			</div>
			<div class="has-text-right">
				<b-button class="is-secondary" @click="resetSearch">Reset</b-button>
				&nbsp;
				<b-button class="is-primary" @click="searchAircraft">Search</b-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			PortfolioId: String
		},
		data() {
			return {
				showAdvanced: false,
				select: ">",
				search: {},
				types: [],
				manufacturers: [],
				models: [],
				selectedManufacturers: [],
				selectedTypes: [],
				selectedModels: []
			}
		},
		mounted() {
			this.resetSearch();
		},
		created() {

			this.searchAircraft();

			this.$http.get("api/aircraft/types")
				.then(resp => {
					this.types = resp.data;
				});

			this.$http.get("api/manufacturer")
				.then(resp => {
					this.manufacturers = resp.data;
				});

			this.$http.get("api/model")
				.then(resp => {
					this.models = resp.data;
				});

		},
		methods: {
			resetSearch() {
				this.search = {
					ModelIds: [],
					ManufacturerIds: [],
					TypeIds: [],
					HourOperator: "=",
					CycleOperator: "=",
				};
			},
			searchAircraft() {
				this.$emit('isLoading');
				this.search.ModelIds = [];
				this.selectedModels.forEach(m => {
					this.search.ModelIds.push(m.Id);
				});

				this.search.ManufacturerIds = [];
				this.selectedManufacturers.forEach(m => {
					this.search.ManufacturerIds.push(m.Id);
				});

				this.search.TypeIds = [];
				this.selectedTypes.forEach(m => {
					this.search.TypeIds.push(m.Id);
				});

				if (this.PortfolioId != null && this.PortfolioId != 0) {
					this.search.PortfolioId = this.PortfolioId;
				}

				this.$http.post("api/aircraft/search", this.search)
					.then(resp => {
						if (resp.data.length > 0) {
							this.$emit("updateAircraft", resp.data);
						} else {
							this.$buefy.toast.open("The search yielded no results.");
						}
						this.$emit('isLoading');
					});
			}
		}
	}
</script>

<style>
</style>
